import { Typography } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const TopMenuTitleTypography = styled(Typography)`
  color: ${theme.palette.logo.main};
  padding-left: ${theme.padding.content};
  font-weight: 600;
  font-size: ${theme.typography.fontSizeBig}px;
`;

export const ChapterTypography = styled(Typography)`
  margin: 50px;
  font-weight: 600;
`;

export const CardTitleTypography = styled(Typography)`
  margin-bottom: ${theme.padding.content};
`;

export const CardOptionTypography = styled(Typography)`
  font-weight: 600;
  margin-bottom: ${theme.padding.small};
`;

export const CardOptionDescriptionTypography = styled(Typography)`
  margin: 0;
`;

export const CardOptionHintTypography = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
`;

export const ModalTypography = styled(Typography)`
  margin-bottom: 10px;
`;

export const TitleTypography = styled(Typography)`
  margin: ${theme.padding.section} 0;
  font-weight: 600;
  font-size: ${theme.typography.fontSizeMedium}px;
`;

export const SubtitleTypography = styled(Typography)`
  margin: ${theme.padding.section} 0;
  font-size: ${theme.typography.fontSize}px;
  text-transform: capitalize;
`;

export const BreadCrumbTypography = styled(Typography)`
  font-size: ${theme.typography.fontSize}px;
  margin-top: 3px;
`;

export const FormHintTypography = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
  margin-bottom: ${theme.padding.content};
`;

export const DescriptionTypography = styled(Typography)`
  color: ${theme.palette.text.secondary};
  padding-right: ${theme.padding.small};
  padding-top: ${theme.padding.small};
  display: inline-block;
`;

export const SecretTypography = styled(Typography)`
  font-size: ${theme.typography.fontSizeSmall}px;
  color: ${theme.palette.text.secondary};
`;
